export default "__VITE_ASSET__364ccdea__"